<mat-card class="charity-selector-card">
  <mat-card-header>
    <mat-card-title>Filter by Charity</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <!-- selectedId bound as well as the events: without it the box's text and this component's filter are
         independent, and any re-emission of the options blanks the box while the list stays filtered. Null for
         "all charities" — the placeholder says so, and naming it in the box would make the box's own text the
         filter for the option list that has to offer it. -->
    <app-filterable-dropdown
      [optionsSetter]="charityOptions"
      [selectedId]="selectedCharityId"
      placeholder="All charities — search to narrow to one..."
      (selectionChange)="onCharitySelected($event)"
      (selectionCleared)="onCharitySelected(null)">
    </app-filterable-dropdown>
  </mat-card-content>
</mat-card>

@if (charityBalance) {
  <mat-card class="balance-card">
    <mat-card-header>
      <mat-card-title>Charity Balance Summary</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="balance-item">
        <span class="balance-label">Total Contributions:</span>
        <span class="balance-value">{{ charityBalance.TotalContributions | formatCurrency }}</span>
      </div>
      <div class="balance-item">
        <span class="balance-label">Total Payouts:</span>
        <span class="balance-value">{{ charityBalance.TotalPayouts | formatCurrency }}</span>
      </div>
      <div class="balance-item amount-owed-item">
        <span class="balance-label">Amount Owed:</span>
        <span class="balance-value amount-owed">{{ charityBalance.AmountOwed | formatCurrency }}</span>
      </div>
    </mat-card-content>
  </mat-card>
}

<!-- The table is always rendered, so "this game has no payouts yet" is a table saying so rather than an
     instruction to pick a charity first (#1411). -->
<mat-card class="summary-card">
  <mat-card-header>
    <mat-card-title>
      {{ showingAllCharities ? 'All Payouts' : 'Payout Summary' }}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="summary-item">
      <span class="summary-label">Total Payouts:</span>
      <span class="summary-value" data-testid="payout-count">{{ (charityPayouts$ | async)?.length }}</span>
    </div>
    <div class="summary-item">
      <span class="summary-label">Total Payout Amount:</span>
      <span class="summary-value total-amount" data-testid="payout-total">{{ totalPayoutAmount | formatCurrency }}</span>
    </div>
  </mat-card-content>
</mat-card>

<app-table-export-buttons
  testIdPrefix="payouts"
  [disabled]="payoutsLoading"
  (exportCsv)="onExportCsv()"
  (exportPdf)="onExportPdf()">
</app-table-export-buttons>

<!-- Paginated because the unfiltered list is now the whole game's history: at the documented ceiling (140
     charities, 313 draws) scrolling one continuous list is not a way to find last week's cheque. -->
<ag-grid-angular
  class="ag-theme-quartz"
  rowClass="payout-row clickable-row"
  [tooltipShowDelay]=0
  domLayout='autoHeight'
  [pagination]="true"
  [paginationPageSize]="50"
  [paginationPageSizeSelector]="[25, 50, 100, 250]"
  data-testid="payout-table"
  [loading]="payoutsLoading"
  [overlayNoRowsTemplate]="showingAllCharities ? '<span>No payouts recorded for this game</span>' : '<span>No payouts for this charity</span>'"
  (gridReady)="onPayoutsGridReady($event)"
  (rowClicked)="onRowClicked($event)"
  [rowData]="charityPayouts$ | async"
  [columnDefs]="payoutColDefs">
</ag-grid-angular>

@if (payoutsLoading) {
  <app-loading-card-content></app-loading-card-content>
}
